import { postForm } from './BaseRequests'


export const postSignup = ({ email, given_name, family_name, password, referral_code, promo_code, phone, type }, success, fail) => {
    postForm("signup", { member: { email, given_name, password, family_name, referral_code, promo_code, phone, type } })
        .then(response => {
            if (response.success) {
                success(true)
            } else {
                if (response.message) {
                    fail(response.message)
                }
                fail("Error with signup request")
            }
        }).catch(fail)
}


export const postVerifyEmail = ({ verificationKey }, success, fail) => {
    postForm("verify_email", { verification_key: verificationKey })
        .then(response => {
            if(response.success){
                success(true)
            }else{
                fail(response.message)
            }
        }).catch(fail)
}
